import { render, staticRenderFns } from "./ProcessRecords.vue?vue&type=template&id=a4aac1d0&"
import script from "./ProcessRecords.vue?vue&type=script&lang=js&"
export * from "./ProcessRecords.vue?vue&type=script&lang=js&"
import style0 from "./ProcessRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4aac1d0')) {
      api.createRecord('a4aac1d0', component.options)
    } else {
      api.reload('a4aac1d0', component.options)
    }
    module.hot.accept("./ProcessRecords.vue?vue&type=template&id=a4aac1d0&", function () {
      api.rerender('a4aac1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/ProcessRecords.vue"
export default component.exports